import { exploreSchemaItemList } from '@/templates/Landing/seoLandings/exploreSchema';
import { ENV } from '@/constants';

export const schemaObject_AiNeonFilter = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/ai-neon-filter',
			name: 'Neon Effect Photo Editor — AI Neon Filter Online | Lift',
			description:
				"Turn photos into neon anime art instantly with Lift's AI neon filter. No watermark. Upload and create now!",
			url: 'https://liftapp.ai/ai-neon-filter',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/ai-neon-filter#product' },
				{ '@id': 'https://liftapp.ai/ai-neon-filter#howto' },
				{ '@id': 'https://liftapp.ai/ai-neon-filter#benefits' },
				{ '@id': 'https://liftapp.ai/ai-neon-filter#faq' },
				{ '@id': 'https://liftapp.ai/ai-neon-filter#why-lift' },
				{ '@id': 'https://liftapp.ai/ai-neon-filter#explore-tools' },
				{ '@id': 'https://liftapp.ai/ai-neon-filter#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/ai-neon-filter#product',
			name: 'AI Neon Filter Online',
			description:
				'Instantly turn yourself into stunning neon anime art with AI. Futuristic cityscapes, holographic effects, and bold neon colors — no design skills needed. Perfect for standout social media posts, avatars, and creative self-expression!',
			url: 'https://liftapp.ai/ai-neon-filter',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/ai-neon-filter#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: "Choose a photo from your device or take one using Lift's app",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Apply the neon filter',
					text: 'Watch as AI transforms your photo into a futuristic anime portrait with neon lights, holographic effects, and sci-fi details',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-neon-filter#benefits',
			name: 'Who Can Benefit from AI Neon Filter?',
			description:
				"Lift's AI Neon Filter is useful for social media users, content creators, digital artists, and anyone looking to create eye-catching neon visuals for personal branding and creative expression.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Social media users crafting neon profile pics and headers',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Content creators building cyberpunk thumbnails or Reels hooks',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Digital artists exploring neon anime aesthetics without drawing',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Gamers and streamers designing futuristic channel branding',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Event promoters teasing nightlife flyers with glowing portraits',
				},
				{
					'@type': 'ListItem',
					position: 6,
					name: 'Anyone refreshing avatars with sci-fi, holographic vibes',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'Neon Photo Filter',
				description:
					'Example of how Lift AI Neon Filter creates stunning neon anime art with futuristic cityscapes and holographic effects.',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/ai-neon-filter#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Neon Filter?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Neon Filter is a online tool that transforms your photos into anime portraits with neon lights, futuristic cityscapes, and holographic effects — perfect for social media, avatars, and creative projects.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does the AI Neon Filter work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Our AI analyzes your photo using deep learning, preserves your facial features, and reimagines them in anime style with neon pink, blue, and purple tones, sharp line art, sci-fi details, and futuristic backgrounds. Everything is automatic — no manual editing or Photoshop skills needed.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I apply the neon filter to any photo?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Yes. Lift works with portraits, selfies, group photos, pets, and any image type. The AI adapts to your photo's content and applies the neon transformation while keeping the essence of your original image.",
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the neon photos without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images created with Lift's AI neon filter can be exported without a watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, printing, or any creative use.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-neon-filter#why-lift',
			name: "Why Lift's AI Neon Filter stands out",
			description:
				"Lift's AI Neon Filter combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'AI Neon Portrait Maker',
				description:
					"Comparison of Lift's AI Neon Filter benefits — high-quality results, intelligent rendering, multi-platform access, and cost savings.",
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/ai-neon-filter#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/ai-neon-filter#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI Neon Filter',
					item: 'https://liftapp.ai/ai-neon-filter',
				},
			],
		},
	],
};
